var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"11","height":"11","viewBox":"0 0 11 11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M6.61676 0V4.48756H11.001V6.49055H6.61676V11H4.36266V6.49055H0.000976562V4.48756H4.36266V0H6.61676Z","fill":"#103A84"}})])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-112bc448","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/components/icons/AddHistoricBuyOrderLight.vue
// module id = gcJY
// module chunks = 0